var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"on-manager":_vm.onManager,"resource":_vm.resource,"status-module":"image"}})}
var staticRenderFns = []

export { render, staticRenderFns }